import React from "react";

export enum TagType {
  default = "default",
  blue = "blue",
  custom = "custom",
}

interface ITag {
  content: string | React.ReactNode;
  tagType?: TagType;
  className?: string;
  customColors?: string;
}

const Tag = ({
  content,
  tagType = TagType.default,
  customColors,
  className,
}: ITag) => {
  const basicStyles =
    "font-ibmPlexSansSemiBold text-mobile-caption md:text-desktop-caption rounded-[50px] px-4 py-[0.5rem] inline-block text-center ";
  const tagTypes = {
    default: `bg-white text-vibrant-green ${basicStyles}`,
    blue: `bg-[#3179E5] text-white ${basicStyles}`,
    custom: `font-ibmPlexSansSemiBold ${customColors}`,
  };

  return (
    <div className={`${basicStyles} ${tagTypes[tagType]} ${className}`}>
      {content}
    </div>
  );
};

export default Tag;
